module.exports = __webpack_public_path__ + "static/media/Shalev-Gerbi-resume.2d9d62a3.pdf";